// extracted by mini-css-extract-plugin
module.exports = {"button--default":"RSDetailHeaderButton_button--default__7eQpv","icon-wrapper":"RSDetailHeaderButton_icon-wrapper__NbSHb","spin":"RSDetailHeaderButton_spin__X3P0_"};